export default __webpack_public_path__ + "static/media/uploadpaymentIcon.65a27b59.svg";